type Out = {
  hasMouse: boolean;
  hasTouch: boolean;
};

export const usePointerSupport = (): Out => {
  const hasMouse = window.matchMedia('(pointer: fine)').matches;
  const hasTouch = window.matchMedia('(pointer: coarse)').matches;

  return {
    hasMouse,
    hasTouch,
  };
};
